import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { SearchRouteService } from './../../../Services/searchroute.service';
import { GeolocationService } from './../../../Services/geolocation.service';
import { SearchResultsComponent } from './../../../Adv/search-results/search-results.component';
import { DTOAdvertisement, AdveristmentsClient } from './../../../api/WickedApiClient';
import { MainService } from './../../../Services/service.service';
import { DTOAdvertisementEx } from './../../../api/LocalModels';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PageEvent } from "@angular/material/paginator";
import { environment } from '../../../../environments/environment';



@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResultsComponent extends SearchResultsComponent implements OnInit {
  public enableSubscription:boolean = false;

  constructor(public service: MainService, public geolocationService: GeolocationService, searchRouteService: SearchRouteService, advertisementClient: AdveristmentsClient, router: Router, route: ActivatedRoute) { 
    super(service, geolocationService, searchRouteService, advertisementClient, router, route);
    this.enableSubscription = service.enableSubscription;
    service.pageName = "Results";
  }

  ngOnInit(){
    super.ngOnInit();
    document.getElementById('scroll-view-content').scrollTop =0;
  }

  openAdv(id: string) {
    this.service.route.navigate([`adv-detail/${id}`]);
  }

  public getAdvTitle(adv: DTOAdvertisementEx) {
    var tag = this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId ? "" : `[${adv.categoryCode}] `;
    return `${tag}${adv.title}`;
  }

  public getImageFromCard(card: DTOAdvertisementEx) {
    if (card.images.length > 0) {
      let mainImage = card.images.filter(v => v.isMain == true);

      if (mainImage.length > 0) {
        return `${environment.apiBaseUrl}/FileGet/${mainImage[0].fileName}/300x700`;
      } else {
        return `${environment.apiBaseUrl}/FileGet/${card.images[0].fileName}/300x700`;
      }
    } else {
      return '';
    }
  }

  showTip(e){
    e.stopPropagation();

    e.target.getElementsByClassName("textTip")[0].style.opacity = "1";
    setTimeout(function(){ 
      e.target.getElementsByClassName("textTip")[0].style.opacity = "0";
    }, 2000);
    
  }
  pageChange(e){
    document.getElementById('scroll-view-content').scrollTop = 0;
  }

}
